import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Directive, Host, Input, Optional, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * I wrote multiple case for ngSwitch because angular can not :(
 * based on original NgSwitchCase implementation:
 * https://github.com/angular/angular/blob/13.3.x/packages/common/src/directives/ng_switch.ts#L136
 */
@Directive({ selector: '[appMultiCase]' })
export class NgMultiCaseDirective extends NgSwitchCase {
  /**
   * aggregate multiple *ngSwitchCase directives, to prevent unnecessary code repetition
   */
  @Input() appMultiCase: any[] = [];

  constructor(
    viewContainer: ViewContainerRef,
    templateRef: TemplateRef<object>,
    @Optional() @Host() private _ngSwitch: NgSwitch
  ) {
    super(viewContainer, templateRef, _ngSwitch);
  }

  // HACK invading hidden members: NgSwitch._matchCase and NgSwitchCase._view
  ngDoCheck() {
    let match = false;
    for (const cs of this.appMultiCase) {
      match = (this._ngSwitch as any)._matchCase(cs);
      if (match) break;
    }
    this['_view'].enforceState(match);
  }
}
